import type { ReactNode } from "react";

import { Button, Tooltip } from "@similarweb/ui-components";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import {
    StyledFooter,
    StyledFooterText,
    StyledFooterCounter,
    StyledButtonsWrapper,
    StyledCancelButton,
} from "./styles";

type ExportPreviewFooterProps = {
    countLabel: ReactNode;
    count: number;
    isExportDisabled: boolean;
    isTooltipShown: boolean;
    tooltipContent: string;
    onCancel: () => void;
    onExport: () => void;
    "data-automation"?: string;
};

export const ExportPreviewFooter = (props: ExportPreviewFooterProps) => {
    const {
        countLabel,
        count,
        isExportDisabled,
        isTooltipShown,
        tooltipContent,
        onCancel,
        onExport,
        "data-automation": dataAutomation,
    } = props;
    const translate = useTranslation();

    return (
        <StyledFooter data-automation={dataAutomation}>
            <StyledFooterText>
                {countLabel}
                <StyledFooterCounter>{` ${count}`}</StyledFooterCounter>
            </StyledFooterText>
            <StyledButtonsWrapper>
                <StyledCancelButton
                    type="flat"
                    onClick={onCancel}
                    data-automation="export-preview-footer-cancel"
                >
                    {translate("si.advanced_search.contacts_export.cancel_export")}
                </StyledCancelButton>
                <Tooltip
                    enabled={isTooltipShown}
                    content={tooltipContent}
                    placement="top"
                >
                    <div>
                        <Button
                            isDisabled={isExportDisabled}
                            onClick={onExport}
                            data-automation="export-preview-footer-export"
                        >
                            {translate("si.common.button.export")}
                        </Button>
                    </div>
                </Tooltip>
            </StyledButtonsWrapper>
        </StyledFooter>
    );
};
